import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'
import { ProfileModel } from './model/profiles'

export const apiGetProfileById = async (profileID: number): Promise<ProfileModel | undefined> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.get(
    // `https://localhost:59923/api/Profiles/${profileID}`
    `${apiSuffixUrl}/api/Profiles/${profileID}`
  ).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiGetProfileByType = async (
  commodity: number,
  profileType: number
): Promise<ProfileModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  const params = {
    commodity,
    profileType
  }

  return await AxiosInstance.get(
    // `https://localhost:59923/api/Profiles/GetProfilesByType`,
    `${apiSuffixUrl}/api/Profiles/GetProfilesByType`,
    { params }
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiGetProfileByLeadType = async (
  commodity: number,
  breakdownLevel: number
): Promise<ProfileModel[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  const params = {
    commodity,
    breakdownLevel
  }

  return await AxiosInstance.get(
    // `https://localhost:59923/api/Profiles/GetProfilesByLeadType`,
    `${apiSuffixUrl}/api/Profiles/GetProfilesByLeadType`,
    { params }
  ).then(response => {
    if (response.data) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiGetIsCodeDuplicated = async (
  profileCode: string,
  profileID: number | undefined
): Promise<boolean> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  const params = {
    profileCode,
    profileID
  }

  return await AxiosInstance.get(
    // `https://localhost:59923/api/Profiles/IsCodeDuplicated`,
    `${apiSuffixUrl}/api/Profiles/IsCodeDuplicated`,
    { params }
  ).then(response => {
    if (response.data !== undefined) {
      return response.data
    }
  })
}

export const apiCreateProfile = async (
  request: ProfileModel
): Promise<ProfileModel | undefined> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.post(
    // `https://localhost:59923/api/Profiles`,
    `${apiSuffixUrl}/api/Profiles`,
    request
  ).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiUpdateProfile = async (
  request: ProfileModel
): Promise<ProfileModel | undefined> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  return await AxiosInstance.patch(
    // `https://localhost:59923/api/Profiles`,
    `${apiSuffixUrl}/api/Profiles`,
    request
  ).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiDeleteProfileById = async (
  profileID: number
): Promise<ProfileModel | undefined> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  // const apiSuffixUrl = 'https://localhost:59140'
  const url = `${apiSuffixUrl}/api/Profiles(${profileID})`

  return await AxiosInstance.delete(url).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiGetIsUsedInAnyLead = async (profileID: number): Promise<boolean> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  // const apiSuffixUrl = 'https://localhost:59140'
  return await AxiosInstance.get(`${apiSuffixUrl}/api/Profiles/IsUsedInAnyLead(${profileID})`).then(
    response => {
      return response.data as boolean
    }
  )
}
